module.exports = __webpack_public_path__ + "b6ed3707dfaf33471d0550c5256db925.svg";